import { useEffect, useState } from "react";
import {
  Row,
  Card,
  Typography,
  Col,
  Button,
  Image,
  Modal,
  Avatar,
  Divider,
} from "antd";
import { getCardStyle } from "../../../../utils/getCardStyle";
import { PauseCircleOutlined, PlayCircleOutlined } from "@ant-design/icons";
const { Text } = Typography;

const PaletMultiCard = ({
  palet,
  darkMode,
  tiposPalet,
  alturasPalet,
  isActive = false,
  onCerrarPalet,
  ordenActiva,
  setModalVisible,
  onEliminarPalet,
  onActivarPalet,
  // State para play/pause lote/vto
  onSetLoteVtoActivo,
  loteVtoActivo,
}) => {
  const [abierto, setAbierto] = useState(isActive);

  // sincroniza si isActive cambia dinámicamente
  useEffect(() => {
    setAbierto(isActive);
  }, [isActive]);

  const tipoPalet = tiposPalet.find((t) => t.idpalt === palet.tipo);
  const alturaPalet = alturasPalet.find((a) => a.idpala === palet.altura);

  return (
    <Col span={24} key={palet.idPalet} id={`palet-${palet.idPalet}`}>
      <Card
        onClick={() => {
          if (onActivarPalet) {
            onActivarPalet(palet.idPalet);
          }
        }}
        hoverable
        styles={{ body: { padding: 16 } }}
        style={{
          ...getCardStyle(darkMode),
          height: "100%",
          flex: 1,
          marginBottom: 8,
          backgroundColor: "#fafafa",
          transition: "background-color 0.3s ease, border 0.3s ease",
          border: isActive ? `2px solid #52c41a` : "1px solid #e8e8e8",
          borderRadius: 8,
          boxShadow: isActive
            ? darkMode
              ? "0 0 0 2px rgba(82, 196, 26, 0.3)"
              : "0 0 0 2px rgba(82, 196, 26, 0.2)"
            : "none",
          cursor: "pointer",
        }}
      >
        {/* FILA 1: ID y etiqueta */}
        <Row align="top" justify="space-between">
          <Col>
            <Text strong style={{ fontSize: 20, color: "#000" }}>
              #{palet.idPalet}
            </Text>
          </Col>
          <Col>
            {!palet.cerrado && isActive && (
              <Button
                type="primary"
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  onCerrarPalet(palet.idPalet);
                }}
              >
                Cerrar Palet
              </Button>
            )}
          </Col>
        </Row>

        {/* FILA 2: Tipo y altura de palet */}
        <Row style={{ marginTop: 8 }}>
          <Col>
            <Text style={{ fontSize: "15px", color: "#888" }}>
              {tipoPalet?.descri} ({tipoPalet?.medpro}×{tipoPalet?.medanc})
            </Text>
            <Text style={{ fontSize: "14px", color: "#555", display: "block" }}>
              {alturaPalet
                ? `${alturaPalet.nombre} (${alturaPalet.medalt} cm)`
                : "-"}
            </Text>
          </Col>
          <Col flex="none" style={{ marginLeft: "auto", marginTop: 8 }}>
            <Avatar
              src="/assets/palet.png"
              size={60}
              style={{ backgroundColor: "#d5c279" }}
            />
          </Col>
        </Row>

        {/* FILA 3: Artículos en el palet (colapsable) */}
        <Row style={{ marginTop: 12 }}>
          <Col span={24}>
            <div
              onClick={(e) => {
                e.stopPropagation();
                setAbierto(!abierto);
              }}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              {palet.articulos.length > 0 && (
                <>
                  <Text strong style={{ fontSize: 17, color: "#000" }}>
                    Artículos ({palet.articulos.length})
                  </Text>
                  <Text style={{ color: "#000", fontSize: 15 }}>
                    {abierto ? "▲" : "▼"}
                  </Text>
                </>
              )}
            </div>

            {abierto && (
              <div style={{ marginTop: 8 }}>
                {palet.articulos.length > 0 ? (
                  Object.values(
                    palet.articulos.reduce((acc, art) => {
                      const key = `${String(art.sku).trim()}-${String(
                        art.nropar ?? "",
                      ).trim()}`;
                      if (!acc[key]) {
                        acc[key] = {
                          sku: art.sku,
                          nropar: art.nropar ?? "",
                          nombre: art.nombre || "-",
                          modelo: art.modelo,
                          cantid: art.cantid,
                          arts: [],
                        };
                      }
                      acc[key].arts.push(art);
                      return acc;
                    }, {}),
                  ).map((grupo, gIdx, gArr) => {
                    const totalSku = grupo.arts.reduce(
                      (sum, a) => sum + Number(a.cantidad || 0),
                      0,
                    );
                    return (
                      <div
                        key={`${grupo.sku}-${grupo.nropar}-${gIdx}`}
                        style={{
                          padding: "6px 0",
                          borderBottom:
                            gIdx < gArr.length - 1
                              ? "1px solid #e8e8e8"
                              : "none", // línea solo entre grupos
                        }}
                      >
                        {/* Apartado de SKU (una sola vez por sku) */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "baseline",
                          }}
                        >
                          <div
                            style={{ flex: 1, minWidth: 0, marginRight: 12 }}
                          >
                            <Text
                              style={{
                                color: "#000",
                                fontSize: 15,
                                fontWeight: 500,
                              }}
                            >
                              {grupo.sku}
                            </Text>
                            <Text
                              style={{
                                color: "#000",
                                fontSize: 15,
                                display: "block",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                marginTop: 2,
                              }}
                            >
                              {grupo.nombre || "-"}
                            </Text>
                          </div>
                          <Text
                            strong
                            style={{
                              fontSize: 20,
                              textAlign: "right",
                              color: "#000",
                            }}
                          >
                            {totalSku} u.
                          </Text>
                        </div>

                        {/* Cada lote/vto de ese SKU, con su play/pause */}
                        {grupo.arts.map((art, aIdx) => {
                          const esLoteVtoActivo =
                            loteVtoActivo &&
                            loteVtoActivo.idPalet === palet.idPalet &&
                            loteVtoActivo.sku === art.sku &&
                            loteVtoActivo.nropar === art.nropar &&
                            loteVtoActivo.lote === art.lote &&
                            loteVtoActivo.vto === art.vto;
                          return (
                            <div
                              key={`${art.sku}-${art.nropar}-${art.lote}-${art.vto}-${aIdx}`}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "4px 0 0 12px",
                              }}
                            >
                              <div
                                style={{
                                  flex: 1,
                                  minWidth: 0,
                                  marginRight: 12,
                                }}
                              >
                                {art.lote || art.vto ? (
                                  <Text
                                    style={{
                                      color: "#444",
                                      fontSize: 15,
                                      display: "block",
                                      lineHeight: "18px",
                                    }}
                                  >
                                    {art.lote && (
                                      <span>
                                        <strong>L:</strong> {art.lote}
                                      </span>
                                    )}
                                    {art.lote && art.vto && (
                                      <span> {" • "} </span>
                                    )}
                                    {art.vto && (
                                      <span>
                                        <strong>V:</strong> {art.vto}
                                      </span>
                                    )}
                                  </Text>
                                ) : (
                                  <Text
                                    style={{
                                      color: "#888",
                                      fontSize: 15,
                                    }}
                                  >
                                    Sin lote/vto
                                  </Text>
                                )}
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 8,
                                }}
                              >
                                <Text
                                  strong
                                  style={{
                                    fontSize: 20,
                                    textAlign: "right",
                                    color: "#000",
                                  }}
                                >
                                  {art.cantidad} u.
                                </Text>

                                {/* !CONTROLES PLAY PAUSE (por lote/vto) */}

                                {!palet?.cerrado && (
                                  <Image
                                    src="/icons/keyboard.png"
                                    preview={false}
                                    style={{
                                      width: 32,
                                      cursor: "pointer",
                                      flexShrink: 0,
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setModalVisible({
                                        status: true,
                                        payload: {
                                          ...art,
                                          sku: art.sku,
                                          origen: "multipalet",
                                          nombre: art.nombre,
                                          parte: art.nropar,
                                          modelo: art.modelo,
                                          ubicacion: "-",
                                          cantidad: art.cantid,
                                          valorInicial: art.ctdaud,
                                          idartl: art.idartl,
                                          idartp: art.idartp,
                                          nropar: art.nropar,
                                          lote: art.lote,
                                          vto: art.vto,
                                          idPalet: palet.idPalet,
                                        },
                                      });
                                    }}
                                  />
                                )}

                                {!palet?.cerrado &&
                                  art.lote &&
                                  art.vto &&
                                  ordenActiva && (
                                    <>
                                      {esLoteVtoActivo ? (
                                        <PauseCircleOutlined
                                          style={{
                                            fontSize: 23,
                                            color: "#faad14",
                                            cursor: "pointer",
                                          }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            onSetLoteVtoActivo?.(null);
                                          }}
                                        />
                                      ) : (
                                        <PlayCircleOutlined
                                          style={{
                                            fontSize: 23,
                                            color: "#52c41a",
                                            cursor: "pointer",
                                          }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            onSetLoteVtoActivo?.({
                                              idPalet: palet.idPalet,
                                              sku: art.sku,
                                              nropar: art.nropar,
                                              lote: art.lote,
                                              vto: art.vto,
                                            });
                                          }}
                                        />
                                      )}
                                    </>
                                  )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })
                ) : (
                  <Text style={{ fontStyle: "italic", color: "#888" }}>
                    Sin artículos
                  </Text>
                )}
              </div>
            )}
          </Col>
        </Row>

        {/* FILA 4: Capacidad */}
        <Row justify="space-between" align="middle" style={{ marginTop: 6 }}>
          <Divider style={{ margin: 6 }} />
          <Col>
            <Text type="secondary" style={{ fontSize: 14, color: "#000" }}>
              Volumen: {palet.volumenOcupadoM3.toFixed(3)} /{" "}
              {palet.capacidadVolM3.toFixed(3)} m³
            </Text>
          </Col>
          <Col>
            <Text strong style={{ fontSize: 20, color: "#000" }}>
              {((palet.volumenOcupadoM3 / palet.capacidadVolM3) * 100).toFixed(
                0,
              )}
              %
            </Text>
          </Col>
        </Row>

        <Row justify="space-between" align="middle" style={{ marginTop: 12 }}>
          <Col />
          {isActive && ordenActiva && (
            <Button
              danger
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                Modal.confirm({
                  title: "¿Quitar palet?",
                  content: ``,
                  okText: "Sí, quitar",
                  okType: "danger",
                  cancelText: "Cancelar",
                  onOk: () => {
                    onEliminarPalet?.(palet.idPalet);
                  },
                });
              }}
            >
              Deshacer palet
            </Button>
          )}
        </Row>
      </Card>
    </Col>
  );
};

export default PaletMultiCard;
